import { Badge, Card, Stack, useMantineTheme } from "@mantine/core"
import { FC, useEffect, useState } from "react"
import { DeviceDocument } from "../../../../contexts/devices-context"
import { httpsCallable } from "firebase/functions"
import { AwsS3GetLatestVideoData } from "../../../../functions/aws/s3/aws-s3-getLatestVideo"
import { firebase } from "../../../../services/firebase/firebase"

type DevicePreviewCardProps = {
    device: DeviceDocument
}

const DevicePreviewCard: FC<DevicePreviewCardProps> = ({ device }) => {
    const [url, setUrl] = useState("")
    const [timestamp, setTimestamp] = useState("")

    useEffect(() => {
        httpsCallable<AwsS3GetLatestVideoData>(
            firebase.functions,
            "aws-s3-getLatestVideo",
        )({
            id: device.id,
            group: device.group,
            organisation: device.organisation,
        })
        .then((result) => {
            // @ts-ignore
            const { url, timestamp } = result.data
            setUrl(url)
            if (timestamp !== null) {
                setTimestamp(timestamp)
            }
        })
        .catch(() => {
            console.log("No latest video to preview.")
        })
    }, [])

    return (
        url && (
            <Card withBorder mih="35vh" h="100%">
                <Stack justify="center" h="100%">
                    <Badge variant="filled" w="9rem" pos="absolute" right="2rem" top="2rem" style={{zIndex: 10}}>{timestamp}</Badge>
                    <video src={url} width="100%" style={{borderRadius: "0.5rem"}} controls></video>
                </Stack>
            </Card>
        )
    )
}

export default DevicePreviewCard